import React from 'react';
import PropTypes from 'prop-types';

export const SpinnerOverlay = ({ children }) => <div className="spinner-overlay">{children}</div>;

const Spinner = () => (
  <SpinnerOverlay>
    <div className="spinner-container">
      <i data-testid="spinner" />
    </div>
  </SpinnerOverlay>
);

SpinnerOverlay.defaultProps = {
  children: null,
};

SpinnerOverlay.propTypes = {
  children: PropTypes.node,
};

export default Spinner;
